export default __webpack_public_path__ + "static/media/fedex.e1b67baa.svg";